import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR,
} from "../store/types";
import store from "../store/store";
import { firebase } from "../config/configureFirebase";
import {
    onValue,
    update,
    set,
    child,
    remove,
    push,
    ref,
    query,
    orderByChild,
} from "firebase/database";
import {
    uploadBytesResumable,
    getDownloadURL,
    getStorage,
    ref as storageRef,
} from "firebase/storage";
import { generateId } from "../helper/helper";

export const fetchCars = () => (dispatch) => {
    const { carsRef } = firebase;

    dispatch({
        type: FETCH_CARS,
        payload: null,
    });

    const userInfo = store.getState().auth.profile;
    console.log("caractions userInfo", userInfo);

    // Add safety checks to prevent ReferenceError
    if (!userInfo || !userInfo.uid || !userInfo.usertype) {
        console.error("caractions: userInfo is invalid:", userInfo);
        dispatch({
            type: FETCH_CARS_FAILED,
            payload: "User information not available",
        });
        return;
    }

    console.log("caractions userInfo.uid", userInfo.uid);
    console.log("caractions userInfo.usertype", userInfo.usertype);

    // Get multiservice settings
    const settings = store.getState().settingsdata.settings;
    const addons = store.getState().addondata.data;
    const isMultiService = addons?.multi_service && settings?.multi_service;
    console.log("caractions isMultiService:", isMultiService);

    // Get cars reference based on user type
    const carsReference = carsRef(userInfo.uid, userInfo.usertype);
    console.log("caractions carsReference", carsReference);

    onValue(
        carsReference,
        (snapshot) => {
            console.log(
                "caractions snapshot received - keys count:",
                Object.keys(snapshot.val() || {}).length
            );
            if (!snapshot.val()) {
                console.log("caractions no cars found in database");
                dispatch({
                    type: FETCH_CARS_FAILED,
                    payload:
                        store.getState().languagedata.defaultLanguage.no_cars,
                });
            } else {
                let data = snapshot.val();
                console.log(
                    "caractions raw data from Firebase - keys:",
                    Object.keys(data || {})
                );

                // Handle different data structures with safety checks
                let arr = [];
                if (!data) {
                    console.log("caractions: data is null or undefined");
                    arr = [];
                } else if (Array.isArray(data)) {
                    // Data is already an array - this is the correct structure from glory.js
                    console.log(
                        "caractions data is array, processing as glory.js structure"
                    );
                    arr = data; // Keep as array of objects with car_id as key
                } else if (typeof data === "object") {
                    // Data is an object, convert to array
                    console.log(
                        "caractions data is object, converting to array"
                    );
                    arr = Object.keys(data).map((key) => {
                        return { [key]: data[key] };
                    });
                } else {
                    console.log(
                        "caractions: unexpected data type:",
                        typeof data
                    );
                    arr = [];
                }

                console.log("caractions processed array length:", arr.length);

                // Filter cars based on multiservice setting
                if (isMultiService) {
                    // If multiservice is TRUE, only show cars with for_multi_service key
                    arr = arr.filter((carGroupObj) => {
                        try {
                            const carId = Object.keys(carGroupObj || {})[0];
                            const carGroup = carGroupObj[carId];
                            const hasForMultiService =
                                carGroup?.for_multi_service === true;

                            console.log(`caractions filtering car ${carId}:`, {
                                for_multi_service: carGroup?.for_multi_service,
                                hasForMultiService: hasForMultiService,
                                isMultiService: isMultiService,
                                shouldShow: hasForMultiService,
                            });

                            return hasForMultiService;
                        } catch (filterError) {
                            console.error(
                                "caractions filter error:",
                                filterError
                            );
                            return false;
                        }
                    });
                    console.log(
                        "caractions filtered array length:",
                        arr.length
                    );
                } else {
                    // If multiservice is FALSE, show cars WITHOUT for_multi_service key (traditional cars)
                    arr = arr.filter((carGroupObj) => {
                        try {
                            const carId = Object.keys(carGroupObj || {})[0];
                            const carGroup = carGroupObj[carId];
                            const hasForMultiService =
                                carGroup?.for_multi_service === true;

                            console.log(`caractions filtering car ${carId}:`, {
                                for_multi_service: carGroup?.for_multi_service,
                                hasForMultiService: hasForMultiService,
                                isMultiService: isMultiService,
                                shouldShow: !hasForMultiService,
                            });

                            return !hasForMultiService; // Show cars WITHOUT for_multi_service
                        } catch (filterError) {
                            console.error(
                                "caractions filter error:",
                                filterError
                            );
                            return false;
                        }
                    });
                    console.log(
                        "caractions filtered array length:",
                        arr.length
                    );
                }

                // Sort descending by createdAt with safety checks
                if (arr && arr.length > 0) {
                    arr.sort((a, b) => {
                        try {
                            const aKey = Object.keys(a || {})[0];
                            const bKey = Object.keys(b || {})[0];
                            const aCreatedAt =
                                (a && a[aKey] && a[aKey].createdAt) || 0;
                            const bCreatedAt =
                                (b && b[bKey] && b[bKey].createdAt) || 0;
                            return bCreatedAt - aCreatedAt;
                        } catch (sortError) {
                            console.error("caractions sort error:", sortError);
                            return 0;
                        }
                    });
                }
                console.log("caractions sorted array length:", arr.length);

                dispatch({
                    type: FETCH_CARS_SUCCESS,
                    payload: arr,
                });
            }
        },
        (error) => {
            console.error("caractions error fetching cars:", error);
            const errorMessage =
                error && error.message ? error.message : "Unknown error";
            dispatch({
                type: FETCH_CARS_FAILED,
                payload: "Error fetching cars: " + errorMessage,
            });
        }
    );
};

export const editCar =
    (car, method, uploadImage = true) =>
    async (dispatch) => {
        const { singleUserRef, carAddRef, carEditRef, carImage } = firebase;
        dispatch({
            type: EDIT_CAR,
            payload: { method, car },
        });

        console.log("data car", method, car);

        if (method === "Add") {
            push(carAddRef, car);
        } else if (method === "Delete") {
            remove(carEditRef(car.id));
        } else if (method === "UpdateImage") {
            if (uploadImage) {
                await uploadBytesResumable(carImage(car.id), car.car_image);
                let image = await getDownloadURL(carImage(car.id));
                let data = car;
                data.car_image = image;
                set(carEditRef(car.id), data);
            } else {
                let data = car;
                data.car_image = car.car_images[0].image;
                set(carEditRef(car.id), data);
            }
            if (car.active && car.driver) {
                update(singleUserRef(car.driver), {
                    updateAt: new Date().getTime(),
                    car_image: image,
                });
            }
        } else {
            console.log("car else", car);
            set(carEditRef(car.id), car);
        }
    };

export const addNewCar = (car, onSuccess, onError) => (dispatch) => {
    try {
        const { carEditRef } = firebase;

        console.log("car", car);

        set(carEditRef(car.id), car);
        onSuccess();
    } catch (error) {
        onError();
    }
};

export const updateUserCarImage = (uid, newData) => (dispatch) => {
    const { singleUserRef } = firebase;

    let updateData = {
        carType: newData.carType,
        category: newData.category,
        vehicleNumber: newData.vehicleNumber,
        vehicleMake: newData.vehicleMake,
        vehicleModel: newData.vehicleModel,
        other_info: newData.other_info,
        car_image: newData.car_images[0].image,
        updateAt: new Date().getTime(),
    };

    // Only set carApproved if multi_service is not enabled
    // For multi-service, carApproved is always true since approval is handled at car level
    if (!newData.multi_service) {
        updateData.carApproved =
            newData.approved || newData.carApproved || false;
    }

    update(singleUserRef(uid), updateData);
};

export const updateUserCarWithImage = (newData, blob) => (dispatch) => {
    const { auth, carAddRef, singleUserRef, carImage } = firebase;

    var carId = push(carAddRef).key;

    uploadBytesResumable(carImage(carId), blob)
        .then(() => {
            blob.close();
            return getDownloadURL(carImage(carId));
        })
        .then((url) => {
            newData.car_image = url;
            set(child(carAddRef, carId), newData);
            if (newData.active) {
                let updateData = {
                    carType: newData.carType,
                    category: newData.category,
                    vehicleNumber: newData.vehicleNumber,
                    vehicleMake: newData.vehicleMake,
                    vehicleModel: newData.vehicleModel,
                    other_info: newData.other_info,
                    car_image: url,
                    updateAt: new Date().getTime(),
                };

                // Only set carApproved if multi_service is not enabled
                // For multi-service, carApproved is always true since approval is handled at car level
                if (!newData.multi_service) {
                    updateData.carApproved =
                        newData.approved || newData.carApproved || false;
                }

                update(singleUserRef(auth.currentUser.uid), updateData);
            }
        });
};
